import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import {
  MetricTable,
  sortNumeric,
  TableTitleBarChart,
  renderLegendsForTable,
  Error,
} from "./../../Utils/Utils.js";

const metric = (cell, row, rowIndex, enumObject) => {
  const props = { ...cell, ...enumObject };
  return <MetricTable {...props} />;
};

class AdsTop5 extends Component {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    // add unique ids
    data.data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "name",
        text: "Ad Name / Impressions",
        style: { width: "500px", minWidth: "500px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableTitleBarChart,
        sort: true,
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpc",
        text: "CPC",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpa",
        text: "CPA",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total",
        text: "Total Spent",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "total",
        order: "desc",
      },
    ];

    return [
      <div key={"legends"}>{renderLegendsForTable()}</div>,
      <BootstrapTable
        keyField="id"
        data={data.data}
        columns={columns}
        //odyContainerClass="table-large-metrics" // there is no such option in v2
        defaultSorted={defaultSorted}
        striped={false}
        hover={false}
        bordered={false}
      />,
    ];
  }
}

export default AdsTop5;
